{
	"meta": {
		"title": "Precios — UpSquad",
		"description": "Precios simples. Empieza gratis sin tarjeta de crédito y sube de plan cuando estés lista para crecer."
	},
	"hero": {
		"eyebrow": "Precios",
		"title": "Precios simples.",
		"title_accent": "Resultados reales.",
		"subtitle": "Empieza gratis. Sin tarjeta de crédito. Sube de plan cuando tu comunidad esté lista para crecer."
	},
	"billing": {
		"monthly": "Mensual",
		"annual": "Anual",
		"save": "Ahorra 20%"
	},
	"tiers": {
		"free": {
			"tagline": "Empieza aquí",
			"name": "Gratis",
			"price": "$0",
			"period": "Prueba de 14 días",
			"description": "Para empezar — prueba todas las funciones básicas con hasta 25 miembros.",
			"cta": "Crear cuenta gratis",
			"footnote": "Sin tarjeta de crédito",
			"features": [
				"Feed social y mensajes directos",
				"Directorio de miembros",
				"Hasta 25 miembros",
				"Panel de administración",
				"Tu URL de comunidad (tuorg.upsquad.us)"
			]
		},
		"pro": {
			"tagline": "Para comunidades en crecimiento",
			"name": "Pro",
			"price_monthly": "$9",
			"price_annual": "$7",
			"period": "/usuario/mes",
			"badge": "Más popular",
			"description": "Desbloquea AI Insights, Match AI y miembros ilimitados.",
			"cta": "Probar Pro",
			"footnote": "Prueba gratuita de 14 días incluida",
			"features": [
				"Todo lo de Gratis",
				"Miembros ilimitados",
				"AI Insights — pregunta lo que quieras sobre tu comunidad",
				"Match AI — networking + agendado 1:1",
				"Eventos (gratis y de pago, con asistencia)",
				"Clips de comunidad y reels de vídeo",
				"Panel de analítica avanzada",
				"Cohortes y grupos",
				"Soporte prioritario"
			]
		},
		"premium": {
			"tagline": "Para organizaciones listas para escalar",
			"name": "Premium",
			"price": "A medida",
			"badge": "App con marca",
			"description": "Todo lo de Pro, más una app móvil totalmente personalizada en 72 horas.",
			"cta": "Hablar con ventas",
			"footnote": "Precio según tamaño y necesidades de la comunidad",
			"features": [
				"Todo lo de Pro",
				"App de iOS y Android con tu marca — en 72 horas",
				"Gestión de App Store (nos encargamos del envío)",
				"Servidor MCP para integraciones empresariales",
				"Integraciones a medida con tus herramientas existentes",
				"Onboarding dedicado",
				"SLA con uptime garantizado",
				"Contrato y facturación a medida"
			]
		}
	},
	"faq": {
		"title": "Preguntas frecuentes",
		"items": {
			"trial": {
				"question": "¿Qué pasa después de mi prueba gratuita de 14 días?",
				"answer": "Tu comunidad sigue funcionando automáticamente en el plan Gratis (hasta 25 miembros). Puedes subir a Pro en cualquier momento para desbloquear miembros ilimitados y funciones de IA."
			},
			"change_plan": {
				"question": "¿Puedo cambiar de plan en cualquier momento?",
				"answer": "Sí. Sube, baja o cancela desde tu panel de administración — los cambios entran en vigor de inmediato, con facturación prorrateada."
			},
			"per_user": {
				"question": "¿Cómo funciona el precio por usuario?",
				"answer": "Pro se factura por miembro activo al mes. Solo pagas por los miembros que de verdad inician sesión y usan UpSquad."
			},
			"branded_app": {
				"question": "¿Qué incluye la app móvil con marca?",
				"answer": "Una app de iOS y Android totalmente personalizada con tu logo, nombre, colores y contenido — publicada en la App Store y Google Play bajo tu marca. Nos encargamos del envío, las actualizaciones y el mantenimiento."
			},
			"setup_fee": {
				"question": "¿Hay coste de instalación?",
				"answer": "Sin coste de instalación en Gratis o Pro. Los clientes Premium reciben onboarding dedicado de guante blanco incluido en el plan."
			},
			"discounts": {
				"question": "¿Ofrecéis descuentos para ONG u organizaciones educativas?",
				"answer": "Sí — ofrecemos descuentos significativos para ONG verificadas, escuelas y organizaciones de base comunitaria. Contacta con ventas para más detalles."
			},
			"match_ai": {
				"question": "¿Qué es Match AI y cómo funciona?",
				"answer": "Match AI analiza los perfiles, objetivos y actividad de los miembros para recomendar las conexiones adecuadas en el momento correcto, y permite a los miembros agendar una reunión 1:1 con un clic."
			},
			"mcp": {
				"question": "¿Qué es el servidor MCP en el plan Premium?",
				"answer": "Un servidor opcional de Model Context Protocol que permite que los datos y herramientas de tu comunidad se conecten de forma segura con asistentes de IA y sistemas empresariales externos."
			}
		}
	}
}
